import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import ScrollToTop from "./Components/ScrollToTop";

// Main Pages
import Home from "./pages/Home";
import Holiday from "./pages/Holiday";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import PlanMyTrip from "./pages/PlanMyTrip";

// Domestic Tours
import SikkimDarjeeling from "./pages/SikkimDarjeeling";
import JagannathPuriYatra from "./pages/JagannathPuriYatra";
import MathuraVrindavanYatra from "./pages/MathuraVrindavanYatra";
import SpitiAdventure from "./pages/SpitiAdventure";
import ShimlaManaliEscape from "./pages/ShimlaManaliEscape";
import AndamanIslandParadise from "./pages/AndamanIslandParadise";
import KashmirTimelessEscape from "./pages/KashmirTimelessEscape";
import MysticalMeghalaya from "./pages/MysticalMeghalaya";
import SacredRoyalRajasthan from "./pages/SacredRoyalRajasthan";
import KashiAyodhya from "./pages/KashiAyodhya";
import LehLadakhHimalayan from "./pages/LehLadakhHimalayan";

// International Tours
import RajasthanRoyal from "./pages/International/RajasthanRoyal";
import HimalayanNepal from "./pages/International/HimalayanNepal";
import BhutanHimalayan from "./pages/International/BhutanHimalayan";
import KedarnathBadrinath from "./pages/International/KedarnathBadrinath";
import GoaCoastal from "./pages/International/GoaCoastal";
import DibangValley from "./pages/International/DibangValley";
import ArunachalPradesh from "./pages/International/ArunachalPradesh";
import Hampi from "./pages/International/Hampi";
import Ujjain from "./pages/International/Ujjain";

const App = () => {
  return (
    <Router>
      {/* Scroll Top */}
      <ScrollToTop />

      {/* Navbar */}
      <Navbar />

      <main style={{ minHeight: "80vh" }}>
        <Routes>

          {/* Main Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/holiday" element={<Holiday />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/plan-my-trip" element={<PlanMyTrip />} />

          {/* Domestic Tours */}

          <Route
            path="/sikkim-darjeeling-escape"
            element={<SikkimDarjeeling />}
          />

          <Route
            path="/jagannath-puri-divine-darshan"
            element={<JagannathPuriYatra />}
          />

          <Route
            path="/mathura-vrindavan-divine-yatra"
            element={<MathuraVrindavanYatra />}
          />

          <Route
            path="/spiti-himalayan-adventure"
            element={<SpitiAdventure />}
          />

          <Route
            path="/shimla-manali-himalayan-escape"
            element={<ShimlaManaliEscape />}
          />

          <Route
            path="/andaman-island-paradise-tour"
            element={<AndamanIslandParadise />}
          />

          <Route
            path="/kashmir-timeless-escape"
            element={<KashmirTimelessEscape />}
          />

          <Route
            path="/mystical-meghalaya-tour"
            element={<MysticalMeghalaya />}
          />

          <Route
            path="/sacred-royal-rajasthan"
            element={<SacredRoyalRajasthan />}
          />

          <Route
            path="/kashi-ayodhya"
            element={<KashiAyodhya />}
          />

          <Route
            path="/leh-ladakh-himalayan"
            element={<LehLadakhHimalayan />}
          />

          {/* International Tours */}

          <Route
            path="/tour/rajasthan-royal-heritage-journey"
            element={<RajasthanRoyal />}
          />

          <Route
            path="/tour/himalayan-nepal-escape"
            element={<HimalayanNepal />}
          />

          <Route
            path="/tour/bhutan-himalayan-escape"
            element={<BhutanHimalayan />}
          />
           <Route
            path="/tour/kedarnath-badrinath-yatra"
            element={<KedarnathBadrinath />}
          />
            <Route
            path="/tour/goa-coastal-escape"
            element={< GoaCoastal />}
          />

           <Route
            path="/tour/dibang-valley-anini-expedition"
            element={< DibangValley />}
          />

           <Route
            path="/tour/arunachal-pradesh-tour"
            element={< ArunachalPradesh />}
          />

           <Route
            path="/tour/hampi-heritage-tour"
            element={< Hampi />}
          />

          <Route
            path="/tour/ujjain-omkareshwar-jyotirlinga"
            element={< Ujjain />}
          />      


        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </Router>
  );
};

export default App;